<div id="block-block-20" class="section block block-block">

    <h3 class="section_title">NEWSLETTER SUBSCRIPTION</h3>


    <div class="content">
        <div class="prefix">
            Get the latest news from the social good space by signing up to our newsletter.
        </div>
        <a class="form-submit" routerLink="/newsletter">Subscribe</a>
    </div>

</div>

<div id="block-block-20" class="section block block-block">

    <h3 class="section_title">SUBMIT AN IDEA
    </h3>


    <div class="content">
        <div class="prefix">
            Do you have an idea for an app related to social good? Exceptional ideas will be considered for funding by
            Vodafone Foundation.
        </div>
        <a class="form-submit" routerLink="/submit-idea">Submit</a>
    </div>

</div>

<div id="block-block-20" class="section block block-block">

    <h3 class="section_title">NEWSLETTER SUBSCRIPTION</h3>


    <div class="content">
        <div class="prefix">
            Get the latest news from the social good space by signing up to our newsletter.
        </div>
        <a class="form-submit" routerLink="/newsletter">Subscribe</a>
    </div>

</div>